export default {
  dataModel: {
    types: ['pair:Group']
  }
};
